import { useQuery } from '@tanstack/react-query';

import { SHARED_QUERY_KEYS } from '@shared/consts/queryKeys.ts';
import { getUserProfileByIdService } from '@shared/services/userProfile/service';
import { ONBOARDING_STATE } from '@shared/types/userProfile.types.ts';
import { UserId } from '@shared/types/users.ts';

interface UserProfileByIdData {
  id: UserId;
  canFetchData: boolean;
}

export function useUserProfileByIdData({ id, canFetchData = false }: UserProfileByIdData) {
  const { data, isPending, isSuccess } = useQuery({
    queryKey: [SHARED_QUERY_KEYS.USER_PROFILE, id],
    queryFn: () => getUserProfileByIdService(id),
    enabled: Boolean(id) && canFetchData,
  });

  const isOnboardingCompleted = data?.onboardingState === ONBOARDING_STATE.COMPLETED;
  const billingInfoState = data?.status;

  return {
    isOnboardingCompleted,
    billingInfoState,
    isPending,
    isSuccess,
  };
}
